import {createContext} from 'react';

export const SlidesContext = createContext(null);